export default __webpack_public_path__ + "static/media/Demon Slayer Katana.4822a5c8.PNG";